module.exports = __webpack_public_path__ + "static/media/EFR-bg.3f1c85c4.jpg";